import { MoveListFilters, MoveOpeningHours } from '@/modules/move/entities';
import {
  MOVE_ACTION,
  MOVE_LIST_FILTERS,
  MOVE_STATUS,
  MOVE_TYPE,
} from '@/modules/move/entities/enums/move';
import { Color } from 'vkit/lib/shared/types';

export const MOVE_ACTION_TRANSLATED_REVERSE: Record<string, MOVE_ACTION> = {
  ['Inclusão']: MOVE_ACTION.CREATION,
  ['Exclusão']: MOVE_ACTION.REMOVAL,
  ['Alteração']: MOVE_ACTION.UPDATE,
};

export const MOVE_TYPE_TRANSLATED: { [key: string]: string } = Object.freeze({
  [MOVE_TYPE.BRADESCO_CREATION]: 'Inclusão',
  [MOVE_TYPE.BRADESCO_REMOVAL]: 'Exclusão',
  [MOVE_TYPE.BRADESCO_UPDATE]: 'Alteração',
  [MOVE_TYPE.DEFAULT_CREATION]: 'Inclusão',
  [MOVE_TYPE.DEFAULT_REMOVAL]: 'Exclusão',
  [MOVE_TYPE.DEFAULT_UPDATE]: 'Alteração',
  [MOVE_TYPE.DEFAULT_CREATION_STONE]: 'Inclusão',
  [MOVE_TYPE.CNU_CREATION]: 'Inclusão',
  [MOVE_TYPE.CNU_UPDATE]: 'Alteração',
  [MOVE_TYPE.CNU_REMOVAL]: 'Exclusão',
  [MOVE_TYPE.DEFAULT_CREATION_HEALTH_CADMUS]: 'Inclusão',
  [MOVE_TYPE.DEFAULT_CREATION_DENTAL_CADMUS]: 'Inclusão',
  [MOVE_TYPE.DEFAULT_CREATION_INSPER]: 'Inclusão',
});

export const MOVE_TYPE_COLLECTION = [
  MOVE_TYPE.BRADESCO_CREATION,
  MOVE_TYPE.BRADESCO_REMOVAL,
  MOVE_TYPE.BRADESCO_UPDATE,
  MOVE_TYPE.DEFAULT_CREATION,
  MOVE_TYPE.DEFAULT_REMOVAL,
  MOVE_TYPE.DEFAULT_UPDATE,
  MOVE_TYPE.DEFAULT_CREATION_STONE,
  MOVE_TYPE.CNU_CREATION,
  MOVE_TYPE.CNU_UPDATE,
  MOVE_TYPE.CNU_REMOVAL,
  MOVE_TYPE.DEFAULT_CREATION_HEALTH_CADMUS,
  MOVE_TYPE.DEFAULT_CREATION_DENTAL_CADMUS,
  MOVE_TYPE.DEFAULT_CREATION_INSPER,
];

export const MOVE_STATUS_TRANSLATED: { [key: string]: string } = Object.freeze({
  [MOVE_STATUS.NOT_INITIALIZED]: 'Pendente',
  [MOVE_STATUS.IN_PROCESS]: 'Processando',
  [MOVE_STATUS.PROCESS_ERROR]: 'Erro',
  [MOVE_STATUS.PROCESS_PROVIDER_ERROR]: 'Processado',
  [MOVE_STATUS.PROCESSED]: 'Finalizado',
  [MOVE_STATUS.REJECTED]: 'Rejeitado',
});

export const MOVE_STATUS_DESCRIPTION: Record<string, string> = Object.freeze({
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.NOT_INITIALIZED]]:
    'O processamento acontece entre 8h e 18h em dias úteis',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.IN_PROCESS]]:
    'Estamos processando os dados dos colaboradores enviados. Isso pode levar alguns minutos',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESSED]]:
    'Tudo certo! Todas as carteirinhas já foram geradas e estão disponíveis para download',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESS_ERROR]]:
    'Não conseguimos processar nenhum dos dados enviados. Revise o arquivo ou entre em contato com o suporte do Portal RH',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESS_PROVIDER_ERROR]]:
    'Os dados foram processados, mas ainda faltam algumas carteirinhas serem liberadas',
});

export const MOVE_STATUS_COLOR: Record<string, Color> = {
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.NOT_INITIALIZED]]: 'colorDefault',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.IN_PROCESS]]: 'light',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.REJECTED]]: 'danger',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESSED]]: 'success',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESS_ERROR]]: 'danger',
  [MOVE_STATUS_TRANSLATED[MOVE_STATUS.PROCESS_PROVIDER_ERROR]]: 'warning',
};

export const MOVE_STATUS_TRANSLATED_REVERSE = Object.keys(MOVE_STATUS_TRANSLATED).reduce(
  (acc: { [key: string]: string }, statusKey) => ({
    ...acc,
    [MOVE_STATUS_TRANSLATED[statusKey]]: statusKey,
  }),
  {},
);

export const MOVE_LIST_FILTERS_COLLECTION = Object.freeze([
  MOVE_LIST_FILTERS.SEARCH,
  MOVE_LIST_FILTERS.TYPE,
  MOVE_LIST_FILTERS.DATE_MIN,
]);

export const MOVE_LIST_PAGE_SIZE_DEFAUlT = 10;
export const MOVE_LIST_INITIAL_PAGE = 1;
export const MOVE_LAYOUT_DEFAULT = 'default';

export const moveListFiltersInitialValues: Partial<MoveListFilters> = {
  q: '',
  createdAtMin: '',
  page: MOVE_LIST_INITIAL_PAGE,
  pageSize: MOVE_LIST_PAGE_SIZE_DEFAUlT,
  sort: '-uploadedAt',
  'rows.beneficiaryStatus': [],
};

export const moveOpeningHoursInitialState: MoveOpeningHours = {
  isOpeningHours: true,
  openingTime: '',
  closingTime: '',
};
